
import React, { useEffect, useRef } from "react";


function drawStar(ctx, x, y, r, color) {
  ctx.save();
  ctx.beginPath();
  ctx.translate(x, y);
  ctx.moveTo(0, 0 - r);
  for (let i = 0; i < 5; i++) {
    ctx.rotate(Math.PI / 5);
    ctx.lineTo(0, 0 - (r * 0.5));
    ctx.rotate(Math.PI / 5);
    ctx.lineTo(0, 0 - r);
  }
  ctx.closePath();
  ctx.fillStyle = color;
  ctx.globalAlpha = 0.85;
  ctx.fill();
  ctx.restore();
}

function drawRibbon(ctx, x, y, w, h, color, angle) {
  ctx.save();
  ctx.translate(x, y);
  ctx.rotate(angle);
  ctx.beginPath();
  ctx.moveTo(0, 0);
  ctx.bezierCurveTo(w / 2, h / 2, w, -h / 2, w, h);
  ctx.lineWidth = 4;
  ctx.strokeStyle = color;
  ctx.globalAlpha = 0.7;
  ctx.stroke();
  ctx.restore();
}

const CelebrationConfetti = ({ show, duration = 1800 }) => {
  const canvasRef = useRef(null);

  useEffect(() => {
    if (!show) return;
    const canvas = canvasRef.current;
    if (!canvas) return;
    const ctx = canvas.getContext("2d");
    const W = window.innerWidth;
    const H = window.innerHeight;
    canvas.width = W;
    canvas.height = H;
    const confettiCount = 40;
    const starCount = 12;
    const ribbonCount = 18;
    const confetti = Array.from({ length: confettiCount }).map(() => ({
      x: Math.random() * W,
      y: Math.random() * H * 0.3,
      r: Math.random() * 12 + 8,
      color: `hsl(${Math.random() * 360}, 90%, 60%)`,
      dx: Math.random() * 3 - 1.5,
      dy: Math.random() * 2 + 2.5,
      opacity: Math.random() * 0.5 + 0.5,
    }));
    const stars = Array.from({ length: starCount }).map(() => ({
      x: Math.random() * W,
      y: Math.random() * H * 0.3,
      r: Math.random() * 14 + 8,
      color: `#FFD700`,
      dx: Math.random() * 2 - 1,
      dy: Math.random() * 2 + 2,
      opacity: Math.random() * 0.7 + 0.3,
    }));
    const ribbons = Array.from({ length: ribbonCount }).map(() => ({
      x: Math.random() * W,
      y: Math.random() * H * 0.3,
      w: Math.random() * 30 + 30,
      h: Math.random() * 18 + 18,
      color: `hsl(${Math.random() * 360}, 80%, 55%)`,
      dx: Math.random() * 2 - 1,
      dy: Math.random() * 2 + 2,
      angle: Math.random() * Math.PI,
      dAngle: Math.random() * 0.04 - 0.02,
      opacity: Math.random() * 0.5 + 0.5,
    }));
    let animationFrame;
    function drawConfetti() {
      ctx.clearRect(0, 0, W, H);
      // Draw circles
      confetti.forEach(c => {
        ctx.save();
        ctx.beginPath();
        ctx.arc(c.x, c.y, c.r, 0, 2 * Math.PI);
        ctx.fillStyle = c.color;
        ctx.globalAlpha = c.opacity;
        ctx.shadowColor = c.color;
        ctx.shadowBlur = 12;
        ctx.fill();
        ctx.restore();
        c.x += c.dx;
        c.y += c.dy;
        if (c.y > H) c.y = -c.r;
        if (c.x > W) c.x = 0;
        if (c.x < 0) c.x = W;
      });
      // Draw stars
      stars.forEach(s => {
        drawStar(ctx, s.x, s.y, s.r, s.color);
        s.x += s.dx;
        s.y += s.dy;
        if (s.y > H) s.y = -s.r;
        if (s.x > W) s.x = 0;
        if (s.x < 0) s.x = W;
      });
      // Draw ribbons
      ribbons.forEach(r => {
        drawRibbon(ctx, r.x, r.y, r.w, r.h, r.color, r.angle);
        r.x += r.dx;
        r.y += r.dy;
        r.angle += r.dAngle;
        if (r.y > H) r.y = -r.h;
        if (r.x > W) r.x = 0;
        if (r.x < 0) r.x = W;
      });
      animationFrame = requestAnimationFrame(drawConfetti);
    }
    drawConfetti();
    const timer = setTimeout(() => {
      cancelAnimationFrame(animationFrame);
      ctx.clearRect(0, 0, W, H);
    }, duration);
    return () => {
      cancelAnimationFrame(animationFrame);
      clearTimeout(timer);
      ctx.clearRect(0, 0, W, H);
    };
  }, [show, duration]);

  return show ? (
    <canvas
      ref={canvasRef}
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100vw",
        height: "100vh",
        pointerEvents: "none",
        zIndex: 100,
      }}
    />
  ) : null;
};

export default CelebrationConfetti;
